export default __webpack_public_path__ + "static/media/15.ff02456e.jpg";